<template>
  <div>
    <a-tabs :active-key="activeKey" @change="changeTab">
      <a-tab-pane
        v-for="item in tabs"
        :key="item.routeName"
        :tab="item.tabName"
      >
        <router-view v-if="activeKey === item.routeName" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { findCarrierTypeOptions } from '@/api/common_options'

export default {
  name: 'SimCardInventoriesShowTab',
  data() {
    return {
      activeKey: '',
      tabs: [
        { routeName: 'sim_card_inventories', tabName: '卡资源入库' },
        ...findCarrierTypeOptions().map(item => ({
          routeName: `sim_card_inventory_statistics_${item.value}`,
          tabName: `${item.label}库存统计`
        }))
      ]
    }
  },
  watch: {
    $route: {
      handler(route) {
        this.activeKey = route.name
      }
    }
  },
  created() {
    this.activeKey = this.$route.name
  },
  methods: {
    changeTab(activeKey) {
      this.activeKey = activeKey
      this.$router.push({ name: activeKey })
    }
  }
}
</script>
